module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"tariffTitle":"Tarife","energyTitle":"Vergütung Energie","ecoTitle":"Vergütung Herkunftsnachweise (HKN)","totalCompensationTitle":"Vergütung total","cancelEdit":"Abbrechen","resetButton":"Rückliefertarife zurücksetzen","tariffCategory":{"STANDARD":"Standard","CUSTOM":"Benutzer definiert"}}}')
  delete Component.options._Ctor
}
